import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

/**
 * API do modo de quitação automática via Pix (painel de pedidos do lojista).
 * Espelha o recurso QuitacaoAutomaticaResource do sistemaadm:
 *   GET  quitacao-automatica/{id}/status   → { bloqueado, elegivel, modoAtivo, termo, fatura }
 *   GET  quitacao-automatica/{id}/extrato  → QuitacaoExtratoView (faturas em aberto + movimentos)
 *   POST quitacao-automatica/{id}/habilitar → { result, message }
 *
 * `auth` é o token do fornecedor (localStorage "chaveSistema"); `idEstab` é o
 * estabelecimento atual do painel (localStorage "estabelecimentoAtualCF").
 */

const headers = auth => ({ "Content-Type": "application/json", Authorization: auth })

export const buscarStatusQuitacao = async function (auth, idEstab) {
    try {
        const response = await api.get(`quitacao-automatica/${idEstab}/status`, {
            headers: headers(auth),
        })
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarStatusQuitacao", { idEstab })
        return null
    }
}

export const buscarExtratoQuitacao = async function (auth, idEstab) {
    try {
        const response = await api.get(`quitacao-automatica/${idEstab}/extrato`, {
            headers: headers(auth),
        })
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarExtratoQuitacao", { idEstab })
        return null
    }
}

export const habilitarQuitacao = async function (auth, idEstab) {
    try {
        const response = await api.post(
            `quitacao-automatica/${idEstab}/habilitar`,
            {},
            { headers: headers(auth) }
        )
        return response.data
    } catch (error) {
        RegistrarLogErro(error, "habilitarQuitacao", { idEstab })
        return { result: "error", message: "Não foi possível ativar a quitação automática. Tente novamente." }
    }
}

/** Id do estabelecimento atualmente selecionado no painel (com fallback nas configs). */
export const getIdEstabelecimentoAtual = function () {
    try {
        const estab = JSON.parse(localStorage.getItem("estabelecimentoAtualCF"))
        if (estab && estab.id) return estab.id
    } catch (e) {
        /* ignore */
    }
    try {
        const configs = JSON.parse(localStorage.getItem("configs"))
        return configs?.user?.parametros?.id || null
    } catch (e) {
        return null
    }
}
